import { render, staticRenderFns } from "./manage-versions.vue?vue&type=template&id=c70791c6&scoped=true&"
import script from "./manage-versions.vue?vue&type=script&lang=js&"
export * from "./manage-versions.vue?vue&type=script&lang=js&"
import style0 from "./manage-versions.vue?vue&type=style&index=0&id=c70791c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70791c6",
  null
  
)

export default component.exports